let activeThemeClass = null;
const themesBySource = new Map();

const getNavbar = () => {
  if (typeof document === 'undefined') {
    return null;
  }

  return document.querySelector('.nav');
};

const applyNavbarTheme = () => {
  const navbar = getNavbar();

  if (!navbar) {
    return;
  }

  if (activeThemeClass) {
    navbar.classList.remove(activeThemeClass);
  }

  const themes = Array.from(themesBySource.values());

  activeThemeClass = themes.length ? `is-${themes[themes.length - 1]}` : null;

  if (activeThemeClass) {
    navbar.classList.add(activeThemeClass);
  }
};

export const setNavbarTheme = (source, theme) => {
  if (!source) {
    return;
  }

  if (!theme) {
    themesBySource.delete(source);
    applyNavbarTheme();
    return;
  }

  themesBySource.delete(source);
  themesBySource.set(source, theme);
  applyNavbarTheme();
};

export const clearNavbarTheme = (source) => {
  if (!source) {
    return;
  }

  themesBySource.delete(source);
  applyNavbarTheme();
};
